const legacyLabelToIcon = {
  'pulversläckare': 'fire-extinguisher',
  'skumsläckare': 'fire-extinguisher',
  'kolsyresläckare': 'fire-extinguisher',
  'vattenbrandsläckare': 'fire-extinguisher',
  'fettbrandsläckare': 'fire-extinguisher',
  'avd-litiumbrandsläckare': 'fire-extinguisher',
  'centrumrulle': 'fire-roll',
  'första hjälpen': 'first-aid',
  'larmknapp brand': 'fire-alarm',
  'larmknapp utrymning': 'evacuate',
  'nödtelefon': 'emergency-phone',
  'utrymningsväg': 'emergency-exit',
  'hänsvisningsarmatur': 'guide-sign',
  'vägledande markering': 'guide-sign',
  'hänsvisningsarmatur efterlysande': 'guide-sign',
  'vägledande markering efterlysande': 'guide-sign',
  'branddörr': 'fire-door1',
  'branddörr magnet': 'fire-door2',
  'branddörr självstängande': 'fire-door3',
  'centralapparat': 'central',
  'brandfilt': 'fire-blanket',
  'nödbelysning': 'emergency-light',
  'avstängning el': 'power-shutoff',
  'röklucka': 'smoke-hatch',
  'handlampa': 'flashlight',
  'hjärtstartare': 'heart-starter',
  'utrymningsplan': 'escape-plan',
  'sprinklercentral': 'sprinkler-central',
  'sprinkler manuell': 'sprinkler-manual',
  'brandvarnare': 'smoke-warner',
  'ögondusch': 'eye-shower',
  'brandcellsgräns': 'brandcellsgrans',
  'släcksystem kök': 'slacksystem_kok',
  'gassläcksystem': 'gasslacksystem',
  'punktskydd': 'punktskydd',
  'siren': 'siren',
  'centralapparat inbrott': 'centralapparat',
  'manöverpanel': 'manoverpanel',
  'rörelsedetektor': 'rorelsedetektor',
  'magnetkontakt': 'magnetkontakt',
  'rökdetektor': 'rokdetektor',
  'larmknapp': 'larmknapp_burglar',
  'vibrationsdetektor': 'vibrationsdetektor',
  'limmad glaskrossdetektor': 'limmad_glaskrossdetektor',
  'rörelsedetektor, foto': 'rorelsedetektor_foto',
  'aukustisk glaskrossdetektor': 'aukustisk_glaskrossdetektor',
  'sektionskort, rio': 'sektionskort_rio',
  'driftlarm': 'driftlarm',
  'läsare/fbk/passage': 'lasare_fbk_passage',
  'livekamera': 'livekamera',
  'router': 'router',
  'utrymningstrappa': 'utrymningstrappa',
  'utrymningsstege': 'utrymningsstege',
  'farlig eletrisk spänning': 'farlig_eletrisk_spanning',
  'truckladdningsplats': 'truckladdningsplats',
  'brandport': 'brandport',
  'adressenhet': 'adressenhet',
  'aukustiskt larmdon, siren': 'akustiskt_larmdon_siren',
  'brandförsvarstablå': 'brandforsvarstabla',
  'centralutrustning': 'centralutrustning',
  'dörrhallarmagnet': 'dorrhallarmagnet',
  'indikeringstablå, dold detektor': 'indikeringstabla_dold_detektor',
  'kombidetektor': 'kombidetektor',
  'linjerökdetektor reflektor': 'linjerokdetektor_reflektor',
  'linjerökdetektor sändare': 'linjerokdetektor_sandare',
  'nätsäkring': 'natsakring',
  'optiskt larmdon': 'optiskt_larmdon',
  'slutmotstånd': 'slutmotstand',
  'strömförsörjning': 'stromforsorjning',
  'värmedetektor, kapslad': 'varmedetektor_kapslad',
  'värmedetektor': 'varmedetektor',
  'gasbehållare': 'gasbehallare',
  'brandgasfläkt': 'brandgasflakt'
};

// 2) Old, localized labels -> new canonical key
// (add entries as needed; these enable i18n + new-icon mapping)
const legacyLabelToKey = {
  'avstängning el': 'power_cut',
  'branddörr': 'fire_door',
  'branddörr magnet': 'fire_door_magnet',
  'branddörr självstängande': 'fire_door_self_closing',
  'brandfilt': 'fire_blanket',
  'pulversläckare': 'powder_extinguisher',
  'skumsläckare': 'foam_extinguisher',
  'kolsyresläckare': 'co2_extinguisher',
  'vattenbrandsläckare': 'water_extinguisher',
  'fettbrandsläckare': 'fat_extinguisher',
  'avd-litiumbrandsläckare': 'avd_lithium_extinguisher',
  'brandvarnare': 'smoke_detector',
  'centralapparat': 'control_panel',
  'centrumrulle': 'central_roll',
  'första hjälpen': 'first_aid',
  'handlampa': 'flashlight',
  'hjärtstartare': 'defibrillator',
  'larmknapp brand': 'alarm_button_fire',
  'larmknapp utrymning': 'alarm_button_evacuation',
  'nödbelysning': 'emergency_lighting',
  'nödtelefon': 'emergency_phone',
  'röklucka': 'smoke_hatch',
  'sprinkler manuell': 'manual_sprinkler',
  'sprinklercentral': 'sprinkler_central',
  'utrymningsväg': 'escape_route',
  'utrymningsplan': 'evacuation_plan',
  'hänsvisningsarmatur': 'direction_sign',
  'hänsvisningsarmatur efterlysande': 'direction_sign_glow',
  'brandcellsgräns': 'fire_compartment_boundary',
  'släcksystem kök': 'kitchen_extinguishing_system',
  'gassläcksystem': 'gas_extinguishing_system',
  'punktskydd': 'point_protection',
  'siren': 'siren',
  'centralapparat inbrott': 'control_panel_burglary',
  'manöverpanel': 'control_panel_manual',
  'rörelsedetektor': 'motion_detector',
  'magnetkontakt': 'magnetic_contact',
  'rökdetektor': 'smoke_detector_electronic',
  'larmknapp': 'alarm_button',
  'vibrationsdetektor': 'vibration_detector',
  'limmad glaskrossdetektor': 'glued_glass_break_detector',
  'rörelsedetektor, foto': 'motion_detector_photo',
  'aukustisk glaskrossdetektor': 'acoustic_glass_break_detector',
  'sektionskort, rio': 'section_card_rio',
  'driftlarm': 'operational_alarm',
  'läsare/fbk/passage': 'reader_fbk_passage',
  'livekamera': 'live_camera',
  'router': 'router',
  'utrymningstrappa': 'evacuation_stairs',
  'utrymningsstege': 'evacuation_ladder',
  'farlig eletrisk spänning': 'dangerous_voltage_alt',
  'truckladdningsplats': 'forklift_charging_area',
  'brandport': 'fire_gate',
  'adressenhet': 'address_unit',
  'aukustiskt larmdon, siren': 'acoustic_alarm_siren',
  'brandförsvarstablå': 'fire_defense_panel',
  'centralutrustning': 'central_equipment',
  'dörrhallarmagnet': 'door_hall_magnet',
  'indikeringstablå, dold detektor': 'indication_panel_hidden_detector',
  'kombidetektor': 'combination_detector',
  'linjerökdetektor reflektor': 'line_smoke_detector_reflector',
  'linjerökdetektor sändare': 'line_smoke_detector_transmitter',
  'nätsäkring': 'main_fuse',
  'optiskt larmdon': 'optical_alarm',
  'slutmotstånd': 'end_resistor',
  'strömförsörjning': 'power_supply',
  'värmedetektor, kapslad': 'heat_detector_encased',
  'värmedetektor': 'heat_detector',
  'gasbehållare': 'gas_container',
  'brandgasfläkt': 'smoke_exhaust_fan'
};

const typeMetaByKey = {
  other: { icon: 'misc' },
  power_cut: { icon: 'power-shutoff' },
  fire_door: { icon: 'fire-door1' },
  fire_door_magnet: { icon: 'fire-door2' },
  fire_door_self_closing: { icon: 'fire-door3' },
  fire_blanket: { icon: 'fire-blanket' },
  powder_extinguisher: { icon: 'fire-extinguisher' },
  foam_extinguisher: { icon: 'fire-extinguisher' },
  co2_extinguisher: { icon: 'fire-extinguisher' },
  water_extinguisher: { icon: 'fire-extinguisher' },
  fat_extinguisher: { icon: 'fire-extinguisher' },
  avd_lithium_extinguisher: { icon: 'fire-extinguisher' },
  smoke_detector: { icon: 'smoke-warner' },
  control_panel: { icon: 'central' },
  central_roll: { icon: 'fire-roll' },
  first_aid: { icon: 'first-aid' },
  flashlight: { icon: 'flashlight' },
  defibrillator: { icon: 'heart-starter' },
  alarm_button_fire: { icon: 'fire-alarm' },
  alarm_button_evacuation: { icon: 'evacuate' },
  emergency_lighting: { icon: 'emergency-light' },
  emergency_phone: { icon: 'emergency-phone' },
  smoke_hatch: { icon: 'smoke-hatch' },
  manual_sprinkler: { icon: 'sprinkler-manual' },
  sprinkler_central: { icon: 'sprinkler-central' },
  escape_route: { icon: 'emergency-exit' },
  evacuation_plan: { icon: 'escape-plan' },
  direction_sign: { icon: 'guide-sign' },
  fire_hydrant: { icon: 'misc' },
  battery_charging: { icon: 'misc' },
  dangerous_voltage: { icon: 'misc' },
  eye_wash: { icon: 'eye-shower' },
  loading_area: { icon: 'misc' }, 
  direction_sign_glow: { icon: 'guide-sign' },
  sub_central: { icon: 'misc' }, 
  flammable_material: { icon: 'misc' }, 
  fire_compartment_boundary: { icon: 'brandcellsgrans' },
  kitchen_extinguishing_system: { icon: 'slacksystem_kok' },
  gas_extinguishing_system: { icon: 'gasslacksystem' },
  point_protection: { icon: 'punktskydd' },
  siren: { icon: 'siren' },
  control_panel_burglary: { icon: 'centralapparat' },
  control_panel_manual: { icon: 'manoverpanel' },
  motion_detector: { icon: 'rorelsedetektor' },
  magnetic_contact: { icon: 'magnetkontakt' },
  smoke_detector_electronic: { icon: 'rokdetektor' },
  alarm_button: { icon: 'larmknapp_burglar' },
  vibration_detector: { icon: 'vibrationsdetektor' },
  glued_glass_break_detector: { icon: 'limmad_glaskrossdetektor' },
  motion_detector_photo: { icon: 'rorelsedetektor_foto' },
  acoustic_glass_break_detector: { icon: 'aukustisk_glaskrossdetektor' },
  section_card_rio: { icon: 'sektionskort_rio' },
  operational_alarm: { icon: 'driftlarm' },
  reader_fbk_passage: { icon: 'lasare_fbk_passage' },
  live_camera: { icon: 'livekamera' },
  router: { icon: 'router' },
  evacuation_stairs: { icon: 'utrymningstrappa' },
  evacuation_ladder: { icon: 'utrymningsstege' },
  dangerous_voltage_alt: { icon: 'farlig_eletrisk_spanning' },
  forklift_charging_area: { icon: 'truckladdningsplats' },
  fire_gate: { icon: 'brandport' },
  address_unit: { icon: 'adressenhet' },
  acoustic_alarm_siren: { icon: 'akustiskt_larmdon_siren' },
  fire_defense_panel: { icon: 'brandforsvarstabla' },
  central_equipment: { icon: 'centralutrustning' },
  door_hall_magnet: { icon: 'dorrhallarmagnet' },
  indication_panel_hidden_detector: { icon: 'indikeringstabla_dold_detektor' },
  combination_detector: { icon: 'kombidetektor' },
  line_smoke_detector_reflector: { icon: 'linjerokdetektor_reflektor' },
  line_smoke_detector_transmitter: { icon: 'linjerokdetektor_sandare' },
  main_fuse: { icon: 'natsakring' },
  optical_alarm: { icon: 'optiskt_larmdon' },
  end_resistor: { icon: 'slutmotstand' },
  power_supply: { icon: 'stromforsorjning' },
  heat_detector_encased: { icon: 'varmedetektor_kapslad' },
  heat_detector: { icon: 'varmedetektor' },
  gas_container: { icon: 'gasbehallare' },
  smoke_exhaust_fan: { icon: 'brandgasflakt' }
};


export default {
	  methods: {
    getType(key) {
      const normalized = this.normalizeTypeBare(key);
      if (typeMetaByKey[normalized]) return typeMetaByKey[normalized];

      const raw = (typeof key === 'string' ? key : key?.key || '').toLowerCase();
      const legacyIcon = legacyLabelToIcon[raw];
      if (legacyIcon) return { icon: legacyIcon };

      return typeMetaByKey.other;
    },

    getFireProtectionGroup(getFireProtectionGroup) {
      return fireProtectionGroupMap[getFireProtectionGroup];
    },
    getFireProtectionGroupMap() {
      return {
        0: this.$t('fire_protection_group.0'),
        1: this.$t('fire_protection_group.1'),
        2: this.$t('fire_protection_group.2'),
        3: this.$t('fire_protection_group.3'),
        4: this.$t('fire_protection_group.4'),
        5: this.$t('fire_protection_group.5')
      };
    },
    getFireProtectionTypes() {
      return Object.keys(typeMetaByKey)
        .map(key => ({
          key,
          label: this.$t(`fire_protection_type.${key}`),
          icon: typeMetaByKey[key].icon
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    },

    normalizeTypeBare(type) {
      if (!type) return '';
      const raw = (typeof type === 'string' ? type : type?.key || '').trim();
      if (!raw) return '';

      const bare = raw.startsWith('fire_protection_type.')
        ? raw.slice('fire_protection_type.'.length)
        : raw;

      if (typeMetaByKey[bare]) return bare;

      const lower = bare.toLowerCase();
      if (legacyLabelToKey[lower]) return legacyLabelToKey[lower];

      return bare;
    },


     tTypeKey(type) {
      const raw = (typeof type === 'string' ? type : type?.key || '').trim();
      if (!raw) return '';

      const normalized = this.normalizeTypeBare(type);
      const fullKey = `fire_protection_type.${normalized}`;
      const translated = this.$t(fullKey);
      if (translated !== fullKey) return translated;

      const lower = raw.toLowerCase();
      if (legacyLabelToKey[lower]) {
        const fullLegacy = `fire_protection_type.${legacyLabelToKey[lower]}`;
        const t2 = this.$t(fullLegacy);
        if (t2 !== fullLegacy) return t2;
      }

      return raw;
    },

    displayFPName(fp) {
      const obj = fp?.fireProtection || fp;
      if (!obj) return '';
      const byType = this.tTypeKey(obj.inventoryType);
      const isGlobal = obj.companyId == null || obj.isGlobal === true;
      return isGlobal ? (byType || obj.name || '') : (obj.name || byType || '');
    },


    displayFPTitle(fp) {
      return this.displayFPName(fp);
    },

    tInstruction(instruction) {
      if (!instruction) return '';

      const raw = instruction.trim();
      const lookupKey = raw.startsWith('instructions.')
        ? raw
        : `instructions.${raw}`;

      const translated = this.$t(lookupKey);

      return translated !== lookupKey ? translated : instruction;
    },


    tDescription(description) {
      if (!description) return '';
      const key = description.trim();

      if (key.startsWith('descriptions.')) {
        const translated = this.$t(key);
        if (translated !== key) return translated;
      }

      return description;
    }
  },
	computed: {
		typeOptions() {
			return Object.keys(typeMetaByKey)
			.map(key => ({
				key,
				label: this.$t(`fire_protection_type.${key}`),
				icon: typeMetaByKey[key].icon
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
		}
	}
};
